import { render, staticRenderFns } from "./mahjongLegacy.vue?vue&type=template&id=0ab2f90f&scoped=true"
import script from "./mahjongLegacy.vue?vue&type=script&lang=js"
export * from "./mahjongLegacy.vue?vue&type=script&lang=js"
import style0 from "./mahjongLegacy.vue?vue&type=style&index=0&id=0ab2f90f&prod&scoped=true&lang=css"
import style1 from "./mahjongLegacy.vue?vue&type=style&index=1&id=0ab2f90f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2f90f",
  null
  
)

export default component.exports